// extracted by mini-css-extract-plugin
export default {"submitText":"SimplifiedSignup_submitText__B+gQu","thankYouText":"SimplifiedSignup_thankYouText__2Uab4","signupBoxContent":"SimplifiedSignup_signupBoxContent__8opkZ"};